import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { authTokenStore } from '@/shared/api'
import { listFleetProviders } from '@/shared/api/__generated__'
import { Button } from '@/shared/ui/button'
import { TextField } from '@/shared/ui/field'
import { TokenSchema } from '../model/schema'

export function LoginForm() {
  const navigate = useNavigate()
  const [token, setToken] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  const submit = async () => {
    const parsed = TokenSchema.safeParse({ token })
    if (!parsed.success) {
      setError(parsed.error.issues[0]?.message ?? 'Невалидный токен')
      return
    }
    setPending(true)
    setError(null)
    authTokenStore.getState().setToken(parsed.data.token)
    try {
      const res = await listFleetProviders()
      if (res.response.ok) {
        await navigate({ to: '/' })
        return
      }
      authTokenStore.getState().setToken(null)
      setError(
        res.response.status === 401 ? 'Токен не подошёл' : `Бэкенд ответил ${res.response.status}`,
      )
    } catch {
      authTokenStore.getState().setToken(null)
      setError('Бэкенд недоступен')
    } finally {
      setPending(false)
    }
  }

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault()
        void submit()
      }}
    >
      <TextField
        label="Admin-токен"
        type="password"
        autoComplete="off"
        placeholder="ADMIN_TOKEN"
        value={token}
        onChange={(e) => setToken(e.target.value)}
        error={error ?? undefined}
        hint="Хранится в этой вкладке до её закрытия — перезагрузка не разлогинивает"
      />
      <Button type="submit" variant="primary" pending={pending} className="w-full">
        Войти
      </Button>
    </form>
  )
}
